import request from '@/utils/request'

/**
 * 用户登录
 * @param {Object} data - 登录参数
 * @param {String} data.username - 用户名
 * @param {String} data.password - 密码
 * @returns {Promise} 登录结果（包含token和用户信息）
 */
export function login(data) {
  return request({
    url: '/auth/login',
    method: 'post',
    data
  })
}

/**
 * 用户注册
 * @param {Object} data - 注册参数
 * @param {String} data.username - 用户名
 * @param {String} data.password - 密码
 * @param {String} data.email - 邮箱（可选，根据后端需求调整）
 * @returns {Promise} 注册结果
 */
export function register(data) {
  return request({
    url: '/auth/register',
    method: 'post',
    data
  })
}

/**
 * 用户退出登录
 * @returns {Promise} 退出结果
 */
export function logout() {
  return request({
    url: '/auth/logout',
    method: 'post'
  })
}